import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { OG_URL } from '../../../const';
import ogImage from '../../../resources/images/og-image.png';
import { getSidebarCollapsed } from '../../../store/slices/globalSlice';
import { setPageCssVariables } from '../../../utils/helper';
import UserMenu from '../../pages/UserMenu';
import Sidebar from '../Menu/Sidebar';
import sidebarStyles from '../Menu/styles.module.scss';
import Header from './Header';
import styles from './styles.module.scss';

const Layout = (props) => {
    const url = OG_URL;
    const { pageClassName = '', children = null, innerContainerClassName = '', isCatalogLayout = null, cssTypeVariable = '' } = props;
    // HORO-10326: the sidebar renders globally so every page (landing,
    // chat, history, etc.) shows the same sticky nav on desktop. CSS hides
    // it on mobile so the hamburger / UserMenu drawer remains the
    // small-screen entry point.
    const sidebarCollapsed = useSelector(getSidebarCollapsed);
    useEffect(() => {
        setPageCssVariables(!!cssTypeVariable && cssTypeVariable);
    }, [cssTypeVariable]);

    // Expose the sidebar's current width as a CSS variable on the document
    // root so any page (PaymentPage, etc.) can offset full-bleed backgrounds
    // away from the sidebar's territory.
    useEffect(() => {
        if (typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        root.style.setProperty('--sidebar-w', sidebarCollapsed ? '70px' : '240px');
        return () => root.style.removeProperty('--sidebar-w');
    }, [sidebarCollapsed]);
    return (
        <>
            <Helmet>
                <meta name="og:type" property="og:type" content="website" />
                <meta name="og:url" property="og:url" content={url} />
                <meta name="og:title" property="og:title" content="The World’s First AI Spiritual Guides" />
                <meta
                    name="og:description"
                    property="og:description"
                    content="Veda AI by Astrology.com - The World’s First AI Spiritual Guides!"
                />
                <meta name="og:image" property="og:image" content={ogImage} />

                <meta name="twitter:card" property="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" property="twitter:url" content={url} />
                <meta name="twitter:title" property="twitter:title" content="The World’s First AI Spiritual Guides" />
                <meta
                    name="twitter:description"
                    property="twitter:description"
                    content="Veda AI by Astrology.com - The World’s First AI Spiritual Guides!"
                />
                <meta name="twitter:image" property="twitter:image" content={ogImage} />
            </Helmet>
            <div
                className={classNames(pageClassName, styles.wrapper, sidebarStyles.pageWithSidebar, {
                    [styles.wrapperLanding]: isCatalogLayout,
                    [sidebarStyles.sidebarCollapsed]: sidebarCollapsed
                })}
            >
                <Header isCatalogPage={isCatalogLayout} />
                <div className={classNames('container relative ', innerContainerClassName)}>
                    <UserMenu />
                    <Sidebar />
                    {!!children && children}
                </div>
            </div>
        </>
    );
};

export default Layout;
